"use strict";

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Button_1 = __importDefault(require("@material-ui/core/Button"));

var Divider_1 = __importDefault(require("@material-ui/core/Divider"));

var Grid_1 = __importDefault(require("@material-ui/core/Grid"));

var LinearProgress_1 = __importDefault(require("@material-ui/core/LinearProgress"));

var TextField_1 = __importDefault(require("@material-ui/core/TextField"));

var Typography_1 = __importDefault(require("@material-ui/core/Typography"));

var react_1 = __importDefault(require("react"));

var react_paginate_1 = __importDefault(require("react-paginate"));

var constants_1 = require("../../constants");

var CollectionCard_1 = __importDefault(require("./CollectionCard"));

var useStyles_1 = __importDefault(require("./useStyles"));
/**
* Collection component.
*/


var Collection = function Collection(_a) {
  var count = _a.count,
      description = _a.description,
      loading = _a.loading,
      name = _a.name,
      onSearch = _a.onSearch,
      onSearchInput = _a.onSearchInput,
      search = _a.search,
      stories = _a.stories,
      onPageChange = _a.onPageChange,
      page = _a.page,
      pageCount = _a.pageCount,
      q = _a.q,
      _b = _a.urlFormatter,
      urlFormatter = _b === void 0 ? '$id' : _b;
  var classes = (0, useStyles_1.default)();
  var storiesCountLabel = count + " Stor" + (count === 1 ? 'y' : 'ies') + " in this Collection";

  var renderCard = function renderCard(story, index) {
    var key = index + "-" + story.id;
    return react_1.default.createElement(Grid_1.default, {
      item: true,
      key: key,
      md: 4,
      sm: 10,
      xl: 3,
      xs: 12
    }, react_1.default.createElement(CollectionCard_1.default, {
      story: story,
      urlFormatter: urlFormatter
    }));
  };

  var renderPagination = function renderPagination() {
    return react_1.default.createElement(react_paginate_1.default, {
      activeClassName: classes.active,
      breakClassName: "break-me",
      breakLabel: "...",
      containerClassName: classes.paginator,
      initialPage: page - 1,
      marginPagesDisplayed: 2,
      nextLabel: "next",
      onPageChange: onPageChange,
      pageClassName: "stories-collection-page",
      pageCount: pageCount,
      pageRangeDisplayed: 5,
      previousLabel: "previous"
    });
  };

  return react_1.default.createElement(Grid_1.default, {
    container: true,
    justifyContent: "center"
  }, react_1.default.createElement(Grid_1.default, {
    className: classes.section,
    item: true,
    xs: 10
  }, react_1.default.createElement(Typography_1.default, {
    color: "primary",
    variant: "h2"
  }, name), description && react_1.default.createElement(Typography_1.default, {
    color: "textSecondary",
    variant: "h6"
  }, description), count ? react_1.default.createElement(Typography_1.default, {
    color: "textSecondary",
    variant: "overline"
  }, storiesCountLabel, q && "found with keyword '" + q + "'") : null), onSearch && react_1.default.createElement(Grid_1.default, {
    className: classes.section,
    item: true,
    xs: 12
  }, react_1.default.createElement("form", {
    onSubmit: onSearch
  }, react_1.default.createElement(TextField_1.default, {
    className: classes.searchField,
    label: "Search Collection...",
    onChange: onSearchInput,
    value: search
  }))), react_1.default.createElement(Grid_1.default, {
    item: true,
    xs: 12
  }, react_1.default.createElement(Divider_1.default, null), loading && react_1.default.createElement(LinearProgress_1.default, {
    variant: "query"
  })), react_1.default.createElement(Grid_1.default, {
    className: classes.section,
    item: true,
    xs: 10
  }, react_1.default.createElement(Grid_1.default, {
    container: true,
    justifyContent: "center",
    spacing: 3
  }, loading || stories.length ? stories.map(renderCard) : react_1.default.createElement(Typography_1.default, {
    variant: "overline"
  }, "No More Stories Found in this Collection."))), react_1.default.createElement(Grid_1.default, {
    className: classes.section,
    item: true,
    xs: 8
  }, pageCount > 1 && renderPagination()), react_1.default.createElement(Grid_1.default, {
    className: classes.section,
    item: true,
    xs: 8
  }, react_1.default.createElement(Button_1.default, {
    className: classes.link,
    color: "secondary",
    href: constants_1.STORIES_API_HOMEPAGE,
    size: "small",
    target: "_blank"
  }, "POWERED BY THE STORIES SERVICE")));
};

Collection.defaultProps = {
  onPageChange: undefined,
  onSearch: undefined,
  onSearchInput: undefined,
  q: undefined,
  search: undefined
};
exports.default = Collection;